// src/utils/lineDefaults.js
import { getColorsByProductCode } from "../constants/colors";
import { getFontsByProductCode } from "../constants/fonts";
import { getHardwareByProductCode } from "../constants/hardwares";
import { getFinishByProductCode} from "../constants/finishes";
import { getThicknessByProductCode} from "../constants/thicknesses";

export const getDefaultLineValues = (selectedProduct) => {
  // === FALLBACK: No product selected ===
  if (!selectedProduct?.code) {
    return {
      size: "02",
      sizeName: "2 inch",
      color: "black_190",
      colorName: "Black",
      font: "Ubuntu",
      text: "",
      price: 0,
      canvasObj: null,
      hardware: "",
      widthInches: 0,
      heightInches: 0,
    };
  }

  // === RESOLVE SIZES ===
  const sizes = selectedProduct.sizes || [];
  const defaultSizeObj = sizes.find(
    (s) => s.code === selectedProduct.defaultSize
  ) ||
    sizes[0] || { code: "02", name: "2 inch" };

  // === RESOLVE COLORS ===
  const colors = getColorsByProductCode(selectedProduct.code) || [];
  const defaultColorObj =
    colors.find((c) => c.code === selectedProduct.defaultColor) ||
    colors[0] ||
    {};

  // === RESOLVE FONTS ===
  const fonts = getFontsByProductCode(selectedProduct.code) || [];
  const defaultFontObj = fonts[0] || {};
  const defaultFont = defaultFontObj.code || defaultFontObj.name || "Ubuntu";

    // === RESOLVE FINISHES ===
  const finishes = getFinishByProductCode(selectedProduct.code) || [];
  const defaultFinishObj = finishes[0] || {};

    // === RESOLVE THICKNESS ===
  const thicknesses = getThicknessByProductCode(selectedProduct.code) || [];
  const defaultThicknessObj = thicknesses[0] || {};


  // === RESOLVE HARDWARE ===
  const hardwares = getHardwareByProductCode(selectedProduct.code) || [];
  const defaultHardware = hardwares[0] || {};

  // === RETURN DEFAULTS ===
  return {
    size: defaultSizeObj.code,
    sizeName: defaultSizeObj.name,
    color: defaultColorObj.mivaname || defaultColorObj.code || "", // ← CORRECT: uses mivaname (Miva) or code
    colorName: defaultColorObj.name || "Unknown",
    finish: defaultFinishObj.code || "",
    thickness: defaultThicknessObj.code || "",
    font: defaultFont,
    text: "",
    price: 0,
    canvasObj: null,
    hardware: defaultHardware.code,
  };
};

